import jQuery from "jquery";
import "jquery-match-height"; // jQuery依存
const responsiveImageMap = require("@yuheiy/responsive-image-map");
import emergence from "emergence.js";
import "magnific-popup"; // jQuery依存
import "magnific-popup/dist/magnific-popup.css";
import ScrollHint from "scroll-hint";
import "scroll-hint/css/scroll-hint.css";
// import "bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';

const $ = typeof jQuery === "function" ? jQuery : null;

document.addEventListener("DOMContentLoaded", function () {
  console.log("[DOMContentLoaded]");

  // [InitProc]
  if (typeof funcEventUtil.funcInitDrow === "function") {
    funcEventUtil.funcInitDrow(false);
  }

  // [PageProc]
  let _bodyClsName = document.querySelector("body").getAttribute("class") || "";
  console.log("-------- [body." + _bodyClsName + "]");
  if (_bodyClsName.split(/ /).indexOf("home") > -1) {
    funcPageJs.funcHome();
  }
  funcPageJs.funcCommon();
});

const funcPageJs = {
  funcHome: function () {
    console.log("---- [funcPageJs.funcHome]");
    console.log("---- [theme:official]");
  },
  funcCommon: function () {
    console.log("---- [funcPageJs.funcCommon]");
  },
};

// -------- --------
const funcEventUtil = {
  funcInitDrow: function (resizeFlag) {
    // funcDebugScrollInfo
    // if (typeof funcDebugScrollInfo === "object") {
    //   funcDebugScrollInfo.funcInit();
    // }
    // magnificPopup設定
    if (typeof jQuery === "function" && typeof $.magnificPopup === "object") {
      console.log("--> Library [jquery.magnific-popup.js]");
      funcMagnificPopup.funcInit();
    }
    // Emergence.js
    if (typeof emergence === "object") {
      console.log("--> Library [emergence.js]");
      funcEmergence.funcInit();
    }
    // ScrollHint
    if (typeof funcScrollHint === "object") {
      console.log("--> Library [scroll-hint.js]");
      funcScrollHint.funcInit();
    }
    // HybridScroll
    if (typeof funcHybridScroll === "object") {
      funcHybridScroll.funcInit();
    }
    // funcAccordionDetailsAnimation
    if (typeof funcAccordionDetailsAnimation === "object") {
      funcAccordionDetailsAnimation.funcInit();
    }
    // funcDialog
    if (typeof funcDialog === "object") {
      funcDialog.funcInit();
    }
    // funcSmoothScroll
    if (typeof funcSmoothScroll === "object") {
      funcSmoothScroll.funcInit();
    }
    // funcViewportContent;
    if (typeof funcViewportContent === "object") {
      funcViewportContent.funcInit();
    }
    // funcApiYoutube;
    if (typeof funcApiYoutube === "object") {
      funcApiYoutube.funcInit();
    }
    // funcToggleUtil;
    if (typeof funcToggleUtil === "object") {
      funcToggleUtil.funcInit();
    }
    // jquery.matchHeight.js
    if (typeof jQuery === "function" && typeof $.fn.matchHeight === "function") {
      $(".mh").matchHeight();
    }
    // jquery.rwdImageMaps.min.js
    if (typeof responsiveImageMap === "function") {
      for (const img of document.querySelectorAll("img[usemap]")) {
        responsiveImageMap(img);
      }
    }
  },
};

const funcMagnificPopup = {
  funcInit: function () {
    console.log("--> Function [funcMagnificPopup.funcInit]");
    if ($(".mfp-inline").length) {
      $(".mfp-inline").magnificPopup({
        type: "inline",
      });
    }
    if ($(".mfp-ajax").length) {
      $(".mfp-ajax").magnificPopup({
        type: "ajax",
      });
    }
    if ($(".mfp-image").length) {
      $(".mfp-image").magnificPopup({
        type: "image",
      });
    }
    if ($("[class*=mfp-list]").length) {
      $("[class*=mfp-list]").each(function () {
        $(this).magnificPopup({
          delegate: "a",
          type: "image",
          gallery: {
            enabled: true,
          },
        });
      });
    }
    if ($(".mfp-youtube").length) {
      $(".mfp-youtube").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      });
    }
    if ($(".mfp-youtube-pc").length) {
      $(".mfp-youtube-pc").magnificPopup({
        disableOn: 768,
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      });
    }
    $(".mfp-close-btn").on("click", function () {
      $(".mfp-close").click();
      return false;
    });
  },
};

const funcEmergence = {
  funcInit: function () {
    console.log("--> Function [funcEmergence.funcInit]");
    this.funcSetting();
    emergence.init({
      reset: false,
      elemCushion: 0.25,
    });
  },
  funcSetting: function () {
    console.log("--> Function [funcEmergence.funcSetting]");
    document.querySelectorAll(".em").forEach((element) => {
      element.setAttribute("data-emergence", "hidden");
      // this.funcSet1(".em_fade", "fade", 0, 0);
      // this.funcSet1(".em_fadeup", "fadeup", 0, 0);
      // this.funcSet1(".em_fadedown", "fadedown", 0, 0);
      // this.funcSet1(".em_fadeleft", "fadeleft", 0, 0);
      // this.funcSet1(".em_faderight", "faderight", 0, 0);
      // this.funcSet1(".em_zoomin", "zoomin", 0, 0);
      // this.funcSet1(".em_zoomout", "zoomout", 0, 0);
      // this.funcSet1(".em_maker", "maker", 0, 0);
      // // ---- Additional Setting
      // this.funcSet1("h1", "fade", 0, 0);
      // this.funcSet1(".start-box");
      // this.funcSet2(".start-box:nth-child(even) .start-box__text", "faderight", 0, 500);
      // this.funcSet2(".start-box:nth-child(odd) .start-box__text", "fadeleft", 0, 500);
    });
  },
  funcSet1: function (className, emType, duration, delay) {
    document.querySelectorAll(className).forEach((element) => {
      element.setAttribute("data-emergence", "hidden");
      element.classList.add("em");
      if (emType) {
        element.classList.add("em_" + emType);
      }
      if (duration) {
        element.classList.add("em_duration_" + duration);
      }
      if (delay) {
        element.classList.add("em_delay_" + delay);
      }
    });
  },
  funcSet2: function (className, emType, duration, delay) {
    document.querySelectorAll(className).forEach((element) => {
      element.classList.add("em", "em_" + emType);
      if (duration) {
        element.classList.add("em_duration__" + duration);
      }
      if (delay) {
        element.classList.add("em_delay_" + delay);
      }
    });
  },
};

const funcScrollHint = {
  funcInit: function () {
    console.log("--> Function [funcScrollHint.funcInit]");
    if (typeof ScrollHint === "function") {
      new ScrollHint(".js-scrollable, .is-scroll-on-mobile", {
        i18n: {
          scrollable: "スクロールできます",
        },
      });
    }
  },
};

const funcHybridScroll = {
  funcInit: function () {
    console.log("--> Function [funcHybridScroll.funcInit]");
    // Hybrid Scroll
    const hsSections = [...document.querySelectorAll(".phscroll")];

    window.addEventListener("scroll", (e) => {
      for (let i = 0; i < hsSections.length; i++) {
        this.funcTransform(hsSections[i]);
      }
    });
  },
  funcTransform: function (hsSection) {
    // console.log("--> Function [funcHybridScroll.funcTransform]");
    const offsetTop = hsSection.offsetTop;
    let percentage = ((window.scrollY - offsetTop) / window.innerHeight) * 100;

    let scroll_cnt = getComputedStyle(hsSection).getPropertyValue("--phscroll_cnt");
    let scroll_width_per = 100 * (scroll_cnt - 1);
    percentage = percentage < 0 ? 0 : percentage > scroll_width_per ? scroll_width_per : percentage;

    const scrollSection = hsSection.querySelector(".phscroll_section");
    scrollSection.style.transform = `translate3d(${-percentage}vw, 0, 0)`;
  },
};

const funcAccordionDetailsAnimation = {
  // アニメーションの時間とイージング
  animTiming: {
    duration: 200,
    easing: "ease-out",
  },
  // アコーディオンを閉じるときのキーフレーム
  closingAnimKeyframes: (content) => [
    {
      height: content.offsetHeight + "px",
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ],
  // アコーディオンを開くときのキーフレーム
  openingAnimKeyframes: (content) => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: content.offsetHeight + "px",
      opacity: 1,
    },
  ],
  // タブを閉じるときのキーフレーム
  closingTabAnimKeyframes: (content) => [
    {
      opacity: 1,
    },
    {
      opacity: 0,
    },
  ],
  // タブを開くときのキーフレーム
  openingTabAnimKeyframes: (content) => [
    {
      opacity: 0,
    },
    {
      opacity: 1,
    },
  ],
  // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  RUNNING_VALUE: "running",
  // アイコン操作用のクラス名
  IS_OPENED_CLASS: "is-opened",
  funcInit: function () {
    console.log("--> Function [funcAccordionDetailsAnimation.funcInit]");
    let _debug = false;
    const details = document.querySelectorAll("details");

    details.forEach((element) => {
      const summary = element.querySelector("summary");
      const content = element.querySelector("summary + div");
      const closeBtns = content.querySelectorAll(":scope .pdetails__close:not(:scope details .pdetails__close)");
      if (closeBtns) {
        closeBtns.forEach((closeBtn) => {
          console.log("---- details-close:" + closeBtn.textContent);
          closeBtn.addEventListener("click", (e) => {
            console.log("-- details-close");
            const elemDetail = e.target.closest("details");
            const hash = e.target.getAttribute("href");
            console.log("-- [hash] " + hash);
            if (_debug) console.log(elemDetail);
            elemDetail.querySelector("summary").click();
            if (hash === "#") {
              e.preventDefault();
              funcSmoothScroll.funcElemTop(elemDetail);
            }
          });
        });
      }

      if (element.getAttribute("open") !== null) {
        element.classList.add(this.IS_OPENED_CLASS);
      }

      summary.addEventListener("click", (event) => {
        // デフォルトの挙動を無効化
        event.preventDefault();

        // タブ判定
        let isTabElement = false;
        if (element.parentElement.dataset.detailsTab) {
          isTabElement = true;
        }

        // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
        if (element.dataset.animStatus === this.RUNNING_VALUE) {
          return;
        }

        // detailsのopen属性を判定
        if (element.open) {
          // アコーディオンを閉じるときの処理

          // アニメーションを実行
          if (isTabElement) {
            return;
            // closingAnim = content.animate(this.closingTabAnimKeyframes(content), this.animTiming);
          } else {
            // アイコン操作用クラスを切り替える(クラスを取り除く)
            element.classList.toggle(this.IS_OPENED_CLASS);
            const closingAnim = content.animate(this.closingAnimKeyframes(content), this.animTiming);
            // アニメーション実行中用の値を付与
            element.dataset.animStatus = this.RUNNING_VALUE;
            // アニメーションの完了後にopen属性を取り除く
            closingAnim.onfinish = () => {
              element.removeAttribute("open");
              element.dataset.animStatus = "";
            };
          }
        } else {
          // アコーディオンを開くときの処理

          // アニメーションを実行
          let openingAnim;
          if (isTabElement) {
            // 未選択タブのクローズ
            const prevContent = element.parentElement.querySelector(":scope > [open]");
            if (prevContent) {
              prevContent.removeAttribute("open");
            }
            // 選択タブのオープン
            element.setAttribute("open", "true");
            openingAnim = content.animate(this.openingTabAnimKeyframes(content), this.animTiming);
          } else {
            element.setAttribute("open", "true");
            // アイコン操作用クラスを切り替える(クラスを付与)
            element.classList.toggle(this.IS_OPENED_CLASS);
            openingAnim = content.animate(this.openingAnimKeyframes(content), this.animTiming);
          }
          // アニメーション実行中用の値を入れる
          element.dataset.animStatus = this.RUNNING_VALUE;
          // アニメーション完了後にアニメーション実行中用の値を取り除く
          openingAnim.onfinish = () => {
            element.dataset.animStatus = "";
          };
        }
      });
    });
  },
};

const funcDialog = {
  funcInit: function () {
    console.log("--> Function [funcDialog.funcInit]");
    this.funcSetDialog();
  },
  funcSetDialog: function () {
    console.log("--> Function [funcDialog.funcSetDialog]");
    document.querySelectorAll("dialog").forEach(function (elemDialog, i) {
      let _hash = elemDialog.getAttribute("id");
      document.querySelectorAll("a[href^='#" + _hash + "']").forEach(function (elemA, i) {
        // console.log(elemA.getAttribute("href"));
        elemA.addEventListener("click", (e) => {
          e.preventDefault();
          console.log(elemDialog.getAttribute("popover"));
          if (elemDialog.getAttribute("popover") === null) {
            elemDialog.showModal();
          } else {
            elemDialog.showPopover();
          }
          elemDialog.scrollTop = 0;
        });
      });
      elemDialog.querySelectorAll(".dialog-close").forEach(function (elemA, i) {
        // console.log(elemA.innerText);
        elemA.addEventListener("click", (e) => {
          e.preventDefault();
          if (elemDialog.getAttribute("popover") === null) {
            elemDialog.close();
          } else {
            elemDialog.hidePopover();
          }
        });
      });
    });
  },
};

const funcSmoothScroll = {
  resize_ob_hnav_height: 0,
  funcInit: function () {
    console.log("--> Function [funcSmoothScroll.funcInit]");
    this.funcPageLoadHash();
    this.funcResizeObserver();
    this.funcPagetop();
    this.funcScrollSet();
  },
  funcGetHnavHeight: function () {
    // 固定ナビ補正
    const _hnav_id = "#hnav";
    let _hnav_height = 0;
    const _hnav_elem = document.querySelector(_hnav_id);
    if (_hnav_elem) {
      if (getComputedStyle(_hnav_elem).getPropertyValue("position") === "fixed") {
        _hnav_height = _hnav_elem.offsetHeight;
      }
    }
    return _hnav_height;
  },
  funcPageLoadHash: function () {
    let _hash = location.hash;
    console.log("--> Function [funcSmoothScroll.funcPageLoadHash] " + _hash);
    if (_hash) {
      this.funcScrollControl(_hash, true);
    } else {
      let _hnav_height = this.funcGetHnavHeight();
      document.querySelector("html").style.setProperty("--hnav-height", _hnav_height + "px");
    }
  },
  funcPagetop: function () {
    console.log("--> Function [funcSmoothScroll.funcPagetop]");
    const elemPagetop = document.querySelector(".pagetop a[href='#pagetop']");
    if (elemPagetop) {
      // body要素に[id="pagetop"]付与
      document.querySelector("body").setAttribute("id", "pagetop");
      // [表示/非表示]切換
      this.funcPagetopIntersectionObserver();
    }
  },
  funcElemTop: function (targetElem) {
    console.log("--> Function [funcSmoothScroll.funcElemTop]");
    console.log("[debug][targetElem.offsetTop] " + targetElem.offsetTop);
    const _hnav_height = this.funcGetHnavHeight();
    if (_hnav_height) {
      console.log("[debug][_hnav_height] " + _hnav_height);
    }
    window.scrollTo({
      top: _hnav_height + targetElem.offsetTop,
      left: 0,
      behavior: "smooth",
    });
  },
  // https://developer.mozilla.org/ja/docs/Web/API/ResizeObserver
  funcResizeObserver: function () {
    console.log("--> Function [funcSmoothScroll.funcResizeObserver]");
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.contentBoxSize) {
          let _hnav_height = this.funcGetHnavHeight();
          if (this.resize_ob_hnav_height !== _hnav_height) {
            this.resize_ob_hnav_height = _hnav_height;
            document.querySelector("html").style.setProperty("--hnav-height", _hnav_height + "px");
            console.log("[ResizeOb][_hnav_height] " + _hnav_height);
          }
        }
      }
    });
    const _hnav_id = "#hnav";
    const _hnav_elem = document.querySelector(_hnav_id);
    if (_hnav_elem) {
      resizeObserver.observe(_hnav_elem);
    }
  },
  // https://qiita.com/ment_RE/items/5152dbf7aadc9932b7b2
  funcPagetopIntersectionObserver: function () {
    console.log("--> Function [funcSmoothScroll.funcPagetopIntersectionObserver]");
    // [表示/非表示]切換
    window.addEventListener("load", () => {
      const border = 200; // 200pxスクロールしたら処理

      const options = {
        root: null,
        rootMargin: `${border}px 0px ${document.body.clientHeight}px 0px`,
        threshold: 1,
      };

      const callback = (entries, observer) => {
        // IntersectionObserverEntryはundefinedの可能性があるので型ガード
        if (typeof entries[0] === "undefined") return;

        // pagetop制御
        const elem = document.querySelector(".pagetop");
        if (entries[0].isIntersecting) {
          // スクロールTOP処理
          // console.log("[funcSmoothScroll.funcPagetopIntersectionObserver][in]");
          elem.classList.remove("pagetop_show");
        } else {
          // スクロール処理
          // console.log("[funcSmoothScroll.funcPagetopIntersectionObserver][out]");
          elem.classList.add("pagetop_show");
        }
      };

      const observer = new IntersectionObserver(callback, options);
      observer.observe(document.body);
    });
  },
  funcScrollSet: function () {
    console.log("--> Function [funcSmoothScroll.funcScrollSet]");
    document.querySelectorAll("a[href^='#']").forEach(function (elem, i) {
      const _hash = elem.getAttribute("href");
      if (_hash.length >= 2) {
        const elemHash = document.querySelector(_hash);
        if (elemHash) {
          if (elemHash.nodeName === "DIALOG") {
            // console.log("[hash][dialog] " + _hash);
            // elem.addEventListener("click", (e) => {
            //   e.preventDefault();
            //   document.querySelector(_hash).showModal();
            // });
          } else if (elemHash.closest(":is([data-details-accordion],[data-details-tab])")) {
            // console.log("[hash][details] " + _hash);
            elem.addEventListener("click", (e) => {
              funcSmoothScroll.funcScrollControl(_hash, false);
            });
          } else {
            // console.log("[hash] " + _hash);
            elem.addEventListener("click", (e) => {
              funcSmoothScroll.funcScrollControl(_hash, false);
            });
          }
        }
      }
    });
  },
  funcScrollControl: function (_hash, _flag_onload) {
    console.log("--> Function [funcSmoothScroll.funcScrollControl] " + _hash);
    let _debug = false;

    // 対象IDが不正な場合[&=%]
    if (_hash.match(/[^#-\w]/)) {
      console.log("[NG-Hash] " + _hash);
      return;
    }

    // 対象IDが無い場合
    const elemHash = document.querySelector(_hash);
    if (elemHash === null) {
      console.log("[NotFoundHash] " + _hash);
      return;
    }

    // ダイアログ・タブ・アコーディオン判定
    let isDialogElement = false;
    let isTabElement1 = false;
    let isTabElement2 = false;
    let isAccordionElement1 = false;
    let isAccordionElement2 = false;
    if (elemHash.nodeName === "DIALOG") {
      isDialogElement = true;
    } else if (elemHash.closest("details")) {
      // アコーディオン判定(1階層)
      if (elemHash.closest("details").parentElement.dataset.detailsAccordion) {
        isAccordionElement1 = true;
        if (_debug) console.log("[isAccordionElement1] true");
      }
      // タブ判定(1階層)
      if (elemHash.closest("details").parentElement.dataset.detailsTab) {
        isTabElement1 = true;
        if (_debug) console.log("[isTabElement1] true");
      }
      // アコーディオン判定(2階層)
      if (elemHash.closest("details").parentElement.closest("details")) {
        if (elemHash.closest("details").parentElement.closest("details").parentElement.dataset.detailsAccordion) {
          isAccordionElement2 = true;
          if (_debug) console.log("[isAccordionElement2] true");
        }
      }
      // タブ判定(2階層)
      if (elemHash.closest("details").parentElement.closest("details")) {
        if (elemHash.closest("details").parentElement.closest("details").parentElement.dataset.detailsTab) {
          isTabElement2 = true;
          if (_debug) console.log("[isTabElement2] true");
        }
      }
    }

    // ダイアログのオープン時
    if (isDialogElement) {
      console.log("[dialog]");
      elemHash.setAttribute("open", true);
      return;
    }

    // アコーディオンのオープン時の補正
    if (isAccordionElement1) {
      if (_debug) console.log("[isAccordionElement1] open?");
      // [未選択タブのクローズ][選択タブのオープン]
      if (elemHash.closest("details")) {
        if (elemHash.closest("details").getAttribute("open") === null) {
          if (_debug) console.log("[isAccordionElement1] is-opend");
          elemHash.closest("details").classList.add("is-opened");
          elemHash.closest("details").setAttribute("open", true);
        }
      }
    }
    if (isAccordionElement2) {
      if (_debug) console.log("[isAccordionElement2] open?");
      // [未選択タブのクローズ][選択タブのオープン]
      if (elemHash.closest("details")) {
        if (elemHash.closest("details").parentElement.closest("details").getAttribute("open") === null) {
          if (_debug) console.log("[isAccordionElement2] is-opend");
          elemHash.closest("details").parentElement.closest("details").classList.add("is-opened");
          elemHash.closest("details").parentElement.closest("details").setAttribute("open", true);
        }
      }
    }

    // タブのオープン時の補正
    if (isTabElement1) {
      // [未選択タブのクローズ][選択タブのオープン]
      if (elemHash.closest("details")) {
        if (_debug) console.log("[isTabElement1] close");
        if (elemHash.closest("details").parentElement.querySelector(":scope > [open]")) {
          elemHash.closest("details").parentElement.querySelector(":scope > [open]").removeAttribute("open");
        }
        elemHash.closest("details").setAttribute("open", true);
      }
    }
    if (isTabElement2) {
      // [未選択タブのクローズ][選択タブのオープン]
      if (elemHash.closest("details")) {
        if (_debug) console.log("[isTabElement2] close");
        if (elemHash.closest("details").parentElement.closest("details").parentElement.querySelector(":scope > [open]")) {
          elemHash.closest("details").parentElement.closest("details").parentElement.querySelector(":scope > [open]").removeAttribute("open");
        }
        if (elemHash.closest(":is([data-details-accordion],[data-details-tab])").closest("details")) {
          elemHash.closest(":is([data-details-accordion],[data-details-tab])").closest("details").setAttribute("open", true);
        }
      }
    }

    // 要素ごとのoffsetTop
    if (_debug) {
      console.log("-------- _debug_start");
      let _tmpScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      console.log("[_tmpScrollTop] " + _tmpScrollTop);
      let _tmpDiv = elemHash.closest(":is([data-details-accordion],[data-details-tab])");
      console.log(_tmpDiv.getBoundingClientRect());
      console.log(_tmpDiv.nodeName + ":" + _tmpDiv.offsetTop + " =? " + (_tmpDiv.getBoundingClientRect().top + _tmpScrollTop));
      console.log();
      console.log("----");
      _tmpDiv.querySelectorAll(":scope > details").forEach((elem) => {
        console.log(elem.getBoundingClientRect());
        console.log(elem.nodeName + ":" + elem.offsetTop + " =? " + (elem.getBoundingClientRect().top + _tmpScrollTop));
        elem.querySelectorAll(":scope > *").forEach((elem) => {
          console.log(elem.getBoundingClientRect());
          console.log(elem.nodeName + ":" + elem.offsetTop + " =? " + (elem.getBoundingClientRect().top + _tmpScrollTop));
        });
      });
      console.log("---- _debug_end");
    }

    // スクロール位置
    let _top_hash = elemHash.offsetTop;
    let _top_details = _top_hash;
    // #id属性を設定する要素で対応可能なため不要
    // if (isTabElement1) {
    //   _top_details = elemHash.closest(":is([data-details-accordion],[data-details-tab])").offsetTop;
    // }
    // 固定ナビ補正
    let _hnav_height = this.funcGetHnavHeight();
    // スクロール処理
    let _top_diff = _top_hash - _top_details;
    if (_debug) console.log("[_top_hash] " + _top_hash + " - [_top_details] " + _top_details + " = [diff] " + (_top_hash - _top_details));
    if (_debug) console.log("[head] " + _hnav_height + " + [diff] " + _top_diff + " = " + (_top_diff + _hnav_height));
    document.querySelector("html").style.setProperty("--diff-height", _top_diff + "px");
    // if (!_flag_onload) {
    //   setTimeout(function () {
    //     document.querySelector("html").style.setProperty("--diff-height", "0px");
    //   }, 0);
    // }
  },
};

const funcDebugScrollInfo = {
  funcInit: function () {
    console.log("--> Function [funcDebugScrollInfo.funcInit]");
    let elemDiv = document.querySelector("#debug");
    if (!elemDiv) {
      elemDiv = document.createElement("div");
      elemDiv.setAttribute("id", "debug");
      elemDiv.classList.add("position-fixed", "bottom-0", "left-0", "opacity-75");
      elemDiv.classList.add("p-5", "bg-white", "border", "border-black");
      elemDiv.innerText = "[scroll:debug]";
      document.querySelector("body").append(elemDiv);
    }
    document.addEventListener("scroll", function () {
      let elemDiv = document.querySelector("#debug");
      let _top = document.querySelector("html").scrollTop;
      let _text = "[scroll:" + _top.toLocaleString() + "px]";
      elemDiv.innerText = _text;
    });
  },
};

const funcApiYoutube = {
  funcInit: function () {
    console.log("--> Function [funcApiYoutube.funcInit]");
    // ★webpackすると使えない
    const elemYoutube = document.querySelector("#youtube[data-yid]");
    if (elemYoutube) {
      const _yid = elemYoutube.dataset.yid;
      elemYoutube.innerText = _yid;
      // console.log("[youtube][yid] " + _yid);

      const scriptEl = document.createElement("script");
      const headEl = document.querySelector("head");
      scriptEl.src = "https://www.youtube.com/iframe_api";
      headEl.appendChild(scriptEl);

      function onYouTubeIframeAPIReady() {
        const player = new YT.Player("youtube", {
          videoId: _yid,
          playerVars: {
            playsinline: 1,
            loop: 1, // ループ
            playlist: _yid,
            controls: 1, // コントローラー表示
            disablekb: 1, // キーボードでの操作をさせない
            autoplay: 1, // 自動再生
            rel: 0, // オススメ動画
            showinfo: 0, // タイトル表示
          },
          events: {
            onReady: onPlayerReady,
          },
        });
      }
      function onPlayerReady(event) {
        console.log("onPlayerReady");
        const player = event.target;
        player.mute();
        player.playVideo();
      }
    }
  },
};

const funcViewportContent = {
  FIXED_PC_BASE_WIDTH: 1200, // 固定PC幅(タブレットの場合：当基準サイズから縮小)
  FIXED_SP_BASE_WIDTH: 375, // 固定SP幅(320px以下の場合：当基準サイズから縮小)
  funcInit: function () {
    const _debug = false;
    console.log("--> Function [funcViewportContent.funcInit]");
    const _ua = window.navigator.userAgent.toLowerCase();
    if (_debug) console.log(_ua);
    document.querySelector("#viewport").remove();
    let _maxMatch = matchMedia("(max-width: " + (this.FIXED_PC_BASE_WIDTH - 1) + "px)");
    let _minMatch = matchMedia("(min-width: 768px)");
    let _maxMatchForSp = matchMedia("(max-width: " + this.FIXED_SP_BASE_WIDTH + "px)");
    if (_debug) console.log("_maxMatch: " + _maxMatch.matches);
    if (_debug) console.log("_minMatch: " + _minMatch.matches);
    if (_debug) console.log("_maxMatchForSp: " + _maxMatchForSp.matches);
    if (_ua.indexOf("iphone") > 0 || _ua.indexOf("ipod") > 0 || _ua.indexOf("ipad") > 0 || (_ua.indexOf("android") > 0 && _ua.indexOf("mobile") > 0)) {
      // mobile
      if (_debug) console.log("mobile");
      if (_maxMatchForSp.matches) {
        // <-375
        if (_debug) console.log("[mobile] <-375 iPhoneSE3以下のサイズ");
        document.querySelector("head").insertAdjacentHTML("afterbegin", '<meta name="viewport" id="viewport" content="width=' + this.FIXED_SP_BASE_WIDTH + '"">');
      } else if (_maxMatch.matches && _minMatch.matches) {
        // 768 <-> 1199
        if (_debug) console.log("[mobile] 768 <-> 1199 iPadMini/Tablet");
        document.querySelector("head").insertAdjacentHTML("afterbegin", '<meta name="viewport" id="viewport" content="width=' + this.FIXED_PC_BASE_WIDTH + '">');
      } else {
        // other
        if (_debug) console.log("[mobile] 321 <-> 767 responsive");
        document.querySelector("head").insertAdjacentHTML("afterbegin", '<meta name="viewport" id="viewport" content="width=device-width,initial-scale=1">');
      }
    } else {
      // PC / iPadAir+Pro
      if (_debug) console.log("[pc]");
      document.querySelector("head").insertAdjacentHTML("afterbegin", '<meta name="viewport" id="viewport" content="width=' + this.FIXED_PC_BASE_WIDTH + '">');
    }
  },
};

const funcToggleUtil = {
  // <a data-toggle-class="active" data-toggle-parent="true" ...>xxxx</a>
  funcInit: function () {
    console.log("--> Function [funcToggleUtil.funcInit]");
    let _debug = false;
    document.querySelectorAll("[data-toggle-class]").forEach((elem) => {
      // if (_debug) console.log(elem);
      elem.addEventListener("click", function (e) {
        let toggleClass = elem.dataset.toggleClass;
        let toggleParent = elem.dataset.toggleParent || "false";
        let toggleId = elem.dataset.toggleId;
        let toggleSibling = elem.dataset.toggleSibling || "true";
        let toggleScroll = elem.dataset.toggleScroll;
        let toggleEvent = elem.dataset.toggleEvent;
        let toggleElem1;
        let toggleElem2;
        if (_debug) console.log("[debug][toggleClass] " + toggleClass);
        if (_debug) console.log("[debug][toggleParent] " + toggleParent);
        if (_debug) console.log("[debug][toggleId] " + toggleId);
        if (_debug) console.log("[debug][toggleSibling] " + toggleSibling);
        if (_debug) console.log("[debug][toggleScroll] " + toggleScroll);

        if (_debug) console.log("[debug][toggleEvent] " + toggleEvent);
        if (toggleEvent) {
          funcToggleUtil.funcToggleEventForOutClick(elem);
        }

        if (_debug) console.log("[debug] elem.dataset");
        if (_debug) console.log(elem.dataset);

        if (toggleParent === "true") {
          toggleElem1 = elem.parentElement;
        } else {
          toggleElem1 = elem;
        }
        if (_debug) console.log("[debug] toggleElem1");
        if (_debug) console.log(toggleElem1);

        if (toggleSibling === "true") {
          funcToggleUtil.funcRemoveClassForElemSibling(toggleElem1, toggleClass);
        }
        toggleElem1.classList.toggle(toggleClass);

        if (toggleId) {
          if (_debug) console.log("[debug][toggleId] " + toggleId);
          toggleElem2 = document.getElementById(toggleId);
          if (_debug) console.log("[debug] toggleElem2");
          if (_debug) console.log(toggleElem2);
          if (toggleSibling === "true") {
            funcToggleUtil.funcRemoveClassForElemSibling(toggleElem2, toggleClass);
          }
          toggleElem2.classList.toggle(toggleClass);
        }
        if (toggleScroll) {
          if (_debug) console.log("[debug][elem.offsetTop] " + elem.offsetTop);
          elem.closest(toggleScroll).scrollTo({
            top: elem.offsetTop,
            left: 0,
            behavior: "smooth",
          });
        }

        e.preventDefault();
        return false;
      });
    });
  },
  funcRemoveClassForElemSibling: function (toggleElem, toggleClass) {
    // console.log("--> Function [funcToggleUtil.funcSiblingRemove]");
    let _debug = false;
    if (1) {
      // 兄弟セレクタのtoggleClass削除
      if (_debug) console.log("[debug] nextElementSibling");
      let tmpElem = toggleElem.nextElementSibling;
      while (tmpElem) {
        if (_debug) console.log(tmpElem);
        tmpElem.classList.remove(toggleClass);
        tmpElem = tmpElem.nextElementSibling;
      }
      if (_debug) console.log("[debug] previousElementSibling");
      tmpElem = toggleElem.previousElementSibling;
      while (tmpElem) {
        if (_debug) console.log(tmpElem);
        tmpElem.classList.remove(toggleClass);
        tmpElem = tmpElem.previousElementSibling;
      }
    } else {
      if (_debug) console.log(toggleElem.parentElement.children);
      Array.from(toggleElem.parentElement.children).forEach((child) => {
        child.classList.remove(toggleClass);
      });
    }
  },
  funcToggleEventForOutClick: function (elem) {
    console.log("--> Function [funcToggleUtil.funcToggleEventForOutClick]");
    let _debug = false;

    // ---- dropdown用の範囲外クリックで閉じる処理
    // https://qiita.com/yuu_1st/items/c02355ea1e138a55cf3e
    let counter = 0;
    const eventlist = [];
    let num;
    if (_debug) console.log(elem);
    if (elem.classList.contains("active")) {
      if (_debug) console.log("skip-addlistener");
    } else {
      num = addlistener("html", "click", funcHandleOutClick, { arg: elem }, true);
      if (_debug) console.log("addlistener=" + num);
    }
    function funcHandleOutClick(e) {
      console.log("[funcHandleOutClick]");
      if (_debug) console.log(e);
      if (_debug) console.log(e.target);
      if (_debug) console.log(this.arg);
      if (e.target.classList.contains("active")) {
        if (_debug) console.log("skip-removelistener");
      } else {
        this.arg.classList.remove("active");
        if (_debug) console.log("remove-active");
      }
      removelistener(num);
      if (_debug) console.log("removelistener=" + num);
    }
    function addlistener(selectors, type, handleEvent, arg = {}, option = null) {
      counter++;
      const eventlistner = { handleEvent, ...arg };
      const array = { counter, selectors, type, eventlistner, option };
      eventlist.push(array);
      const docs = document.querySelectorAll(selectors);
      for (const doc of docs) {
        doc.addEventListener(type, eventlistner, option);
      }
      return counter;
    }
    function removelistener(num) {
      const find_in = (e) => e.counter === num;
      const value = eventlist.findIndex(find_in);
      const { selectors, type, eventlistner, option } = eventlist[value];
      const docs = document.querySelectorAll(selectors);
      for (const doc of docs) {
        doc.removeEventListener(type, eventlistner, option);
      }
    }
  },
};

const funcSkeleton = {
  funcInit: function () {
    console.log("--> Function [funcSkeleton.funcInit]");
  },
};
